/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
    mutation AccountForgotPasswordResetMutation($email: EmailAddress!) {
        AccountForgotPasswordReset(email: $email) {
            status,
            message
        }
    }
`
